export const OnboardingRouteConstants = [
  { name: 'LoginPage', path: '/logginn/:product' },
  { name: 'LoginPageWithUid', path: '/:uid/logginn/:product' },
  { name: 'ContinueProcessRedirector', path: '/:uid/fortsett/:product' },
  { name: 'OngoingApplicationsPage', path: '/pagaende-soknader/:product/:productScope' },
  { name: 'ProductOverviewStandardProductSelect', path: '/:uid/produkt/standard-flervalg/:product' },
  { name: 'CardAndAccountStandardPage', path: '/:uid/produkt/konto-og-kort/:product' },
  { name: 'CardAndAccountFramPage', path: '/:uid/produkt/konto-og-kort-fram/:product' },
  { name: 'CardAndAccountPrivateBankingPage', path: '/:uid/produkt/konto-og-kort-private-banking/:product' },
  { name: 'ProductOverviewPrivateBankingIntro', path: '/:uid/produkt/private-banking-intro/:product' },
  { name: 'ProductOverviewPrivateBankingProductSelect', path: '/:uid/produkt/private-banking-flervalg/:product' },
  { name: 'ProductOverviewFramMembership', path: '/:uid/produkt/fokus/medlemskap/:product' },
  { name: 'ProductOverviewHighInterestAccountHuseierne', path: '/:uid/produkt/hoyrentekonto-huseierne/:product' },
  { name: 'ProductOverviewFramProductSelect', path: '/:uid/produkt/fram-flervalg/:product' },
  { name: 'ConsentPrivacy', path: '/:uid/samtykke/personvern/:product' },
  { name: 'ConsentDigitalCustomerRelation', path: '/:uid/samtykke/digitalt-kundeforhold/:product' },
  { name: 'ConsentDigitalMarketing', path: '/:uid/samtykke/digital-markedsforing/:product' },
  { name: 'ConsentPersonalData', path: '/:uid/samtykke/personopplysninger/:product' },
  { name: 'SignDocuments', path: '/:uid/signering/dokument/:product' },
  { name: 'SignDocumentsReceipt', path: '/:uid/signering/fullfort/:product' },
  { name: 'CreateApplicationPage', path: '/opprett/:product' },
  { name: 'ManualApplicationStatus', path: '/:uid/signering/behandlesmanuelt/:product' },
  { name: 'ApplicationNotFoundPage', path: '/:uid/soknad-ikke-funnet/:product' },
  { name: 'HuseierneAccountAlreadyExistsPage', path: '/huseierne-konto-finnes-allerede/:product' },
  {
    name: 'QuestionContactInformationAndCitizenshipsOverview',
    path: '/:uid/sporsmal/kontaktinformasjon-og-statsborgerskap-oversikt/:product',
  },
  { name: 'ProductSummaryStandard', path: '/:uid/produkt/oppsummering/:product' },
  { name: 'ProductSummaryFram', path: '/:uid/produkt/oppsummering-fram/:product' },
  { name: 'ProductSummaryPrivateBanking', path: '/:uid/produkt/oppsummering-private-banking/:product' },
] as const;

export const AmlRouteConstants = [
  { name: 'QuestionIntro', path: '/:uid/sporsmal/intro/:product' },
  { name: 'QuestionAmericanTaxLiability', path: '/:uid/sporsmal/amerikansk-skatteplikt/:product' },
  { name: 'QuestionOtherTaxLiabilities', path: '/:uid/sporsmal/andre-skatteplikt/:product' },
  { name: 'QuestionOtherTaxLiabilitiesCountrySelect', path: '/:uid/sporsmal/andre-skatteplikt/:product/land' },
  { name: 'QuestionPep', path: '/:uid/sporsmal/pep/:product' },
  { name: 'QuestionJobstatus', path: '/:uid/sporsmal/jobbsituasjon/:product' },
  { name: 'QuestionMaritalstatus', path: '/:uid/sporsmal/sivilstatus/:product' },
  { name: 'QuestionBankingPurpose', path: '/:uid/sporsmal/bruk/:product' },
  { name: 'QuestionCrypto', path: '/:uid/sporsmal/krypto/:product' },
  { name: 'QuestionMainIncome', path: '/:uid/sporsmal/hovedinntekt/:product' },
  { name: 'QuestionBankingOnBehalfOfOthers', path: '/:uid/sporsmal/paa-vegne-av-andre/:product' },
  { name: 'QuestionCashTransactionsOut', path: '/:uid/sporsmal/kontanttransaksjoner-ut/:product' },
  { name: 'QuestionCashTransactionsOutPurpose', path: '/:uid/sporsmal/kontanttransaksjoner-ut/:product/hensikt' },
  { name: 'QuestionCashTransactionsIn', path: '/:uid/sporsmal/kontanttransaksjoner-inn/:product' },
  { name: 'QuestionCashTransactionsInSource', path: '/:uid/sporsmal/kontanttransaksjoner-inn/:product/kilde' },
  { name: 'QuestionSendTransfer', path: '/:uid/sporsmal/overforinger-fra-norge/:product' },
  { name: 'QuestionSendTransferCountrySelect', path: '/:uid/sporsmal/overforinger-fra-norge/:product/land' },
  { name: 'QuestionSendTransferCountryDetails', path: '/:uid/sporsmal/overforinger-fra-norge/:product/land/:country' },
  { name: 'QuestionReceiveTransfer', path: '/:uid/sporsmal/overforinger-til-norge/:product' },
  { name: 'QuestionReceiveTransferCountrySelect', path: '/:uid/sporsmal/overforinger-til-norge/:product/land' },
  {
    name: 'QuestionReceiveTransferCountryDetails',
    path: '/:uid/sporsmal/overforinger-til-norge/:product/land/:country',
  },
  { name: 'QuestionOutro', path: '/:uid/sporsmal/outro/:product' },
] as const;

export type AmlRouteName = (typeof AmlRouteConstants)[number]['name'];
export type OnboardingRouteName = (typeof OnboardingRouteConstants)[number]['name'];

export type AmlPath = (typeof AmlRouteConstants)[number]['path'];
export type OnboardingPath = (typeof OnboardingRouteConstants)[number]['path'];

export type RouteName = AmlRouteName | OnboardingRouteName;
export type RoutePath = AmlPath | OnboardingPath;

function arrayToObject<T extends readonly { name: string; path: string }[]>(arr: T) {
  return Object.fromEntries(arr.map(({ name, path }) => [name, path])) as {
    [K in T[number] as K['name']]: K['path'];
  };
}

export const routes = {
  ...arrayToObject(OnboardingRouteConstants),
  ...arrayToObject(AmlRouteConstants),
} as const;

type ExtractParams<T extends string> = T extends `${string}:${infer Param}/${infer Rest}`
  ? Param | ExtractParams<Rest>
  : T extends `${string}:${infer Param}`
    ? Param
    : never;

export const addParamsToPath = <TPath extends RoutePath>(
  path: TPath,
  params: { [K in ExtractParams<typeof path>]: string }
): string =>
  Object.entries(params).reduce<string>(
    (updatedPath, [key, value]: [string, string]) => updatedPath.replace(`:${key}`, value),
    path
  );
